const menuPaperStyles = (theme) => ({
  boxShadow: theme.ascend.shadows[5],
  mt: "8px",
  ".MuiList-root": {
    paddingY: "4px"
  }
});
export {
  menuPaperStyles
};
//# sourceMappingURL=Menu.styles.js.map
